module.exports = __webpack_public_path__ + "static/media/hevo-logo.4ec682e9.svg";